/**
 * Handles tab switching with smooth fade-in animation for the new-collection section
 */
(function() {
  'use strict';

  function initCollectionTabs() {
    const sections = document.querySelectorAll('.new-collection-section');
    
    sections.forEach(section => {
      /** @type {HTMLElement[]} */
      const tabs = Array.from(section.querySelectorAll('.new-collection__tab'));
      /** @type {HTMLElement[]} */
      const panels = Array.from(section.querySelectorAll('.new-collection__panel'));
      
      if (tabs.length === 0 || panels.length === 0) {
        return;
      }

      let currentIndex = tabs.findIndex(tab => tab.classList.contains('new-collection__tab--active'));
      if (currentIndex < 0) currentIndex = 0;

      // Initialize first panel
      initializePanel(panels[currentIndex]);

      // Add click handlers to tabs
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => switchTab(index));
        tab.addEventListener('keydown', (/** @type {KeyboardEvent} */ e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            switchTab(index);
          }
        });
      });

      /**
       * Switch to a different tab
       * @param {number} newIndex - The index of the tab to switch to
       */
      function switchTab(newIndex) {
        if (newIndex === currentIndex || newIndex < 0 || newIndex >= tabs.length) {
          return;
        }

        const oldIndex = currentIndex;
        currentIndex = newIndex;

        // Update tab states
        tabs[oldIndex].classList.remove('new-collection__tab--active');
        tabs[oldIndex].setAttribute('aria-selected', 'false');
        tabs[newIndex].classList.add('new-collection__tab--active');
        tabs[newIndex].setAttribute('aria-selected', 'true');

        // Fade out current panel, then fade in new panel
        fadeOutPanel(panels[oldIndex], () => {
          fadeInPanel(panels[newIndex]);
        });
      }

      /**
       * Initialize a panel (show it immediately without animation)
       * @param {HTMLElement} panel - The panel to initialize
       */
      function initializePanel(panel) {
        if (panel) {
          panel.hidden = false;
          panel.classList.add('new-collection__panel--active');
          panel.style.opacity = '1';
          panel.style.visibility = 'visible';
        }
      }

      /**
       * Fade out a panel
       * @param {HTMLElement} panel - The panel to fade out
       * @param {Function} callback - Callback to execute after fade out
       */
      function fadeOutPanel(panel, callback) {
        if (!panel) {
          if (callback) callback();
          return;
        }

        // Start fade out
        panel.style.opacity = '0';
        panel.style.transition = 'opacity 0.3s ease-in-out, visibility 0.3s ease-in-out';

        // Wait for transition to complete
        const handleTransitionEnd = () => {
          panel.removeEventListener('transitionend', handleTransitionEnd);
          panel.classList.remove('new-collection__panel--active');
          panel.hidden = true;
          panel.style.visibility = 'hidden';
          if (callback) callback();
        };

        panel.addEventListener('transitionend', handleTransitionEnd, { once: true });

        // Fallback timeout in case transitionend doesn't fire
        setTimeout(() => {
          if (panel.classList.contains('new-collection__panel--active')) {
            handleTransitionEnd();
          }
        }, 350);
      }

      /**
       * Fade in a panel
       * @param {HTMLElement} panel - The panel to fade in
       */
      function fadeInPanel(panel) {
        if (!panel) {
          return;
        }

        // Prepare panel for fade in
        panel.hidden = false;
        panel.style.opacity = '0';
        panel.style.visibility = 'visible';
        panel.style.transition = 'opacity 0.4s ease-in-out, visibility 0.4s ease-in-out';

        // Force reflow to ensure initial state is applied
        panel.offsetHeight;

        // Start fade in
        requestAnimationFrame(() => {
          panel.classList.add('new-collection__panel--active');
          panel.style.opacity = '1';
        });
      }
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollectionTabs);
  } else {
    initCollectionTabs();
  }
})();

